export const wl1Contract  ={
  "address": "0xeE38CcfA3726a2aA8B168BDCc05D60A2397f94C8",
  "_format": "hh-sol-artifact-1",
  "contractName": "WL1",
  "sourceName": "contracts/WL1.sol",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "src",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "guy",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "dst",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "Deposit",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "src",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "dst",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "src",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "Withdrawal",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "guy",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "deposit",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "dst",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "src",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "dst",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "wad",
          "type": "uint256"
        }
      ],
      "name": "withdraw",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "stateMutability": "payable",
      "type": "receive"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};
